import { render } from "./SpentListPage.vue?vue&type=template&id=593d7b35&ts=true"
import script from "./SpentListPage.vue?vue&type=script&lang=ts"
export * from "./SpentListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__